// Article Overview category dropdown
function toggleTagDropdown() {
  const $toggleTrigger = $('.js-popular-tags-trigger');

  if ($toggleTrigger.length > 0) {
    $toggleTrigger.on('click', function() {
      const $submenu = $(this).prev().find('.popular-tags-more');
      const $text = $(this).find('span');
      const $icon = $(this).find('i');

      $submenu.toggleClass('open');

      if ($submenu.hasClass('open')) {
        $submenu.slideDown();
        $icon.removeClass();
        $icon.addClass('ico-minus');
        $text.text('View less categories');
      } else {
        $submenu.slideUp();
        $icon.removeClass();
        $icon.addClass('ico-plus');
        $text.text('View more categories');
      }
    });
  }
}

export default { toggleTagDropdown };



// WEBPACK FOOTER //
// ./src/js/custom/tag-dropdown.js